import { createPaginatedSlice } from "../../helpers/reduxHelper";

const uploadsPage = createPaginatedSlice('uploadsPage');

export const uploadsPageActions = uploadsPage.actions
export const uploadsPageSelector = state => state.uploadsPage;
export const uploadsPageReducer = uploadsPage.reducer;
export default uploadsPageReducer

export const uploadsPageSelectors = uploadsPage.LF.selectors